import React from 'react';
import PropTypes from 'prop-types';
import { allowedMessageProps } from '../../lists/SystemMessages';

const InputFieldDefault = ({ inputAttributes, message, label, description, customChangeHandler }) => {
  const finalInputAttributes = {
    ...inputAttributes,
    'aria-invalid': !!message
  };

  if (customChangeHandler) {
    finalInputAttributes.onChange = function ({ target: { value } }) {
      customChangeHandler({ value });
    };
  }

  if (!label) {
    finalInputAttributes.title = description;
  }

  return <input {...finalInputAttributes} />;
};

InputFieldDefault.propTypes = {
  inputAttributes: PropTypes.shape({
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.bool
    ]).isRequired
  }).isRequired,
  label: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string,
    PropTypes.bool
  ]),
  description: PropTypes.string.isRequired,
  message: PropTypes.shape(allowedMessageProps),
  customChangeHandler: PropTypes.func
};

export default InputFieldDefault;